import React, { Component } from "react";

import UserInfos from "./components/UserInfos";
import SearchInput from "./components/SearchInput";

class NavBar extends Component {
  render() {
    return (
      <div>
        <nav className="navbar navbar-expand-md navbar-dark custom-navbar-prop">
          <span className="navbar-brand">
            <a href="/" className="navbar-brand custom-brand-font mr-0">
              <img
                src="/assets/LogoCS.png"
                height="30"
                alt="Logo CentraleSupélec"
              />
              {" Annuaire"}
            </a>
            <a
              href="https://viarezo.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-brand custom-brand-font d-none d-lg-inline"
            >
              <span className="custom-alternative-text-color-navbar">
                {" "}
                by <span className="earthOrbiter">ViAREZO</span>
              </span>
            </a>
          </span>
          <SearchInput />
          <ul className="navbar-nav ml-auto">
            <UserInfos userInfos={this.props.userInfos} link="#" />
          </ul>
        </nav>
      </div>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar/index.js